const AutotaskManage = () => import('@/views/account/integrations/autotask/autotask-manage-view');
const AutotaskConnect = () => import('@/views/account/integrations/autotask/autotask-connect-view');
// const AutotaskAuthenticationSuccess = () => import('@/views/account/integrations/autotask/autotask-authentication-success');

import store from '@/stores/index';

import AutotaskMappingRoutes from '@/routes/integrations/autotask/mapping';
import AutotaskImportRoutes from '@/routes/integrations/autotask/import';

export default [
    {
        path: '/Integrations/Autotask/Manage',
        name: 'AutotaskManage',
        component: AutotaskManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Autotask Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage',
        name: 'ClientAutotaskManage',
        component: AutotaskManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Autotask Integration'
        }
    },
    {
        path: '/Integrations/Autotask/Manage/Connection',
        name: 'AutotaskManageConnection',
        component: AutotaskConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Autotask Connection'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Connection',
        name: 'ClientAutotaskManageConnection',
        component: AutotaskConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Autotask Connection'
        }
    },
    // {
    //     path: '/Integrations/Autotask/AuthenticationSuccess',
    //     name: 'Authentication Success',
    //     component: AutotaskAuthenticationSuccess,
    //     props: true,
    //     meta: {
    //         isUiShown: true,
    //         subtype: 'account',
    //         pageClass: 'integration-settings-page',
    //         pageTitle: 'Authentication Success'
    //     },
    //     beforeEnter: (to, from, next) => {
    //         if (!store.getters.isAdmin) {
    //             next('/Unauthorized');
    //         } else {
    //             next();
    //         }
    //     }
    // },
    ...AutotaskMappingRoutes,
    ...AutotaskImportRoutes
]